import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shipping"
export default class extends Controller {
  static targets = ["form", "destination", "method"]
  static values = { 
    destination: String, 
    method: String,
    cartItemsSize: { type: Number, default: 0 }
  }

  connect() {
    console.log("Shipping controller connected", {
      destination: this.destinationValue,
      method: this.methodValue,
      cartItemsSize: this.cartItemsSizeValue
    })
    
    // Set initial UI state
    this.updateShippingMethods()
    
    // Set the selected method if one is specified
    if (this.methodValue && this.cartItemsSizeValue > 0) {
      this.selectMethod(this.methodValue)
    }
  }

  // Handle destination change
  destinationChanged(event) {
    //console.log("Destination changed to:", event.target.value)
    this.destinationValue = event.target.value
    this.updateShippingMethods()
    this.submitForm()
  }

  // Handle shipping method change
  methodChanged(event) {
    //console.log("Method changed to:", event.target.value)
    this.methodValue = event.target.value
    this.submitForm()
  }

  // Submit the form via Turbo
  submitForm() {
    if (this.hasFormTarget) {
      //console.log("Submitting form...")
      // Add a small delay to prevent rapid-fire submissions
      clearTimeout(this.submitTimeout)
      this.submitTimeout = setTimeout(() => {
        // Use Turbo's built-in form submission
        this.formTarget.requestSubmit()
      }, 100)
    }
  }

  // Update shipping methods based on destination - matches cart.js SM.setUI logic
  updateShippingMethods() {
    if (!this.hasDestinationTarget) return
    
    const destination = this.destinationValue || this.destinationTarget.value
    const cartItemsSize = this.cartItemsSizeValue
    
    //console.log("Updating shipping methods", { destination, cartItemsSize })
    
    // Get all shipping method elements
    const methods = {
      'FINT': document.getElementById('row_FINT'),
      'USPS': document.getElementById('row_USPS'), 
      'FGR': document.getElementById('row_FGR'),
      'F2D': document.getElementById('row_F2D'),
      'FOV': document.getElementById('row_FOV'),
      'CASTD': document.getElementById('row_CASTD'),
      'CAEXP': document.getElementById('row_CAEXP')
    }
    
    // Hide all methods first
    Object.values(methods).forEach(element => {
      if (element) {
        element.style.display = 'none'
        const input = element.querySelector('input[type="radio"]')
        if (input) input.disabled = true
      }
    })
    
    // If cart is empty, keep all methods hidden
    if (cartItemsSize === 0) {
      //console.log("Cart is empty, hiding all shipping methods")
      return
    }
    
    // Show appropriate methods based on destination
    if (destination === "INT") {
      // International: Only FINT
      this.enableMethod(methods.FINT)
    } else if (destination === "MIL") {
      // Military: Only USPS
      this.enableMethod(methods.USPS)
    } else if (destination === "CAN") {
      // Canada: Only CASTD and CAEXP
      this.enableMethod(methods.CASTD)
      this.enableMethod(methods.CAEXP)
    } else if (destination === "USA" || destination === "NY" || destination) {
      // USA: FGR, F2D, FOV
      this.enableMethod(methods.FGR)
      this.enableMethod(methods.F2D)
      this.enableMethod(methods.FOV)
    }
  }

  // Helper to enable a shipping method
  enableMethod(methodElement) {
    if (methodElement) {
      methodElement.style.display = 'block'
      const input = methodElement.querySelector('input[type="radio"]')
      if (input) input.disabled = false
    }
  }

  // Select a specific shipping method - matches cart.js SM.selectOnLoad logic
  selectMethod(methodValue) {
    if (!methodValue || this.cartItemsSizeValue === 0) return
    
    //console.log("Selecting method:", methodValue)
    const radioInputs = this.element.querySelectorAll('input[name="ship_method"]')
    radioInputs.forEach(input => {
      if (input.value === methodValue && !input.disabled) {
        input.checked = true
        //console.log("Selected method:", methodValue)
      }
    })
  }
}